import {SketchLineMultiRelationConstraint} from './SketchLineMultiRelationConstraint';
import {SketchRelationKind} from "../../index";
import {SketchLineObject} from "../../../../../mesh/sketch";

let count = 0;


/**
 * 线-相等关系约束。
 */
export function isLineEqualConstraint(value: object): value is LineEqualConstraint {
    return Reflect.get(value, "isLineEqualConstraint") === true;
}

export class LineEqualConstraint extends SketchLineMultiRelationConstraint<SketchLineObject> {
    readonly isLineEqualConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.Equal;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '相等';
    }

}


